<template>
  <div class="dovemed-container">
    <div class="dovemed-wrapper text-center signup-page">
      <div class="signup-container">
        <h1 class="hyper-link mb-4">Provide Information</h1>
        <p class="mb-1">
          Please provide your full name, NPI number and state license details.
        </p>
        <form class="mt-5">
          <div class="row mb-3">
            <div class="col-md-6 col-sm-12 text-left mb-2">
              <label for="firstName" class="mb-1 input-label">First Name</label>
              <a-input :size="'large'" placeholder="Provide First Name" />
            </div>
            <div class="col-md-6 col-sm-12 text-left mb-2">
              <label for="middleName" class="mb-1 input-label"
                >Middle Name</label
              >
              <a-input :size="'large'" placeholder="Provide Middle Name" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6 col-sm-12 text-left mb-2">
              <label for="lastName" class="mb-1 input-label">Last Name</label>
              <a-input :size="'large'" placeholder="Provide Last Name" />
            </div>
            <div class="col-md-6 col-sm-12 text-left mb-2">
              <label for="npiNumber" class="mb-1 input-label">NPI Number</label>
              <a-input :size="'large'" placeholder="123 456 789" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6 col-sm-12 mb-2 text-left">
              <label for="license" class="mb-1 input-label"
                >State License</label
              >
              <a-input :size="'large'" placeholder="ex. California" />
            </div>
            <div class="col-md-6 col-sm-12 mb-2 text-left">
              <label for="licenseNumber" class="mb-1 input-label"
                >License Number</label
              >
              <a-input :size="'large'" placeholder="xxx xxx xxx" />
            </div>
          </div>
          <p class="text-left">
            <a-radio :size="'large'"></a-radio
            ><span
              class="cp"
              @click="() => $refs.TermsAndConditionsModal.show()"
              ><u>Terms and Conditions.</u></span
            >
          </p>
        </form>
        <div class="buttons-group mt-5 text-right">
          <button
            class="dovemed-button hyper-link"
            :style="{
              border: '1px solid ' + getPrimaryColor(),
              color: getPrimaryColor(),
              background: '#fff',
            }"
            @click="redirectBack()"
          >
            CANCEL
          </button>
          <button
            @click="() => $refs.DoctorProfileTY.show()"
            class="dovemed-button font-white ml-4 primary-button"
            :style="{ background: getPrimaryColor() }"
          >
            SUBMIT
          </button>
        </div>
        <DoctorProfileTY ref="DoctorProfileTY" />
        <TermsAndConditionsModal ref="TermsAndConditionsModal" />
      </div>
    </div>
  </div>
</template>

<script>
import TermsAndConditionsModal from "../Modals/TermsConditions";
import DoctorProfileTY from "../Modals/DoctorProfileTY";
export default {
  name: "DoctorProfile",
  components: {
    TermsAndConditionsModal,
    DoctorProfileTY,
  },
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang='scss' scoped>
.signup-page {
  padding: 70px;
}

.terms-modal-container {
  padding: 30px;
  text-align: center;

  .terms-title {
    padding-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/DoctorProfile.vue